import { NON_CORE_SECTION_SCORES_MAP } from "../config";
import { ResumeAnalysis } from "../resume-analysis/resume-analyse-types";
import { getStatementScore } from "../statment-analysis-scoring";



export const getLanguagesScore = (languages: ResumeAnalysis["languages"], maxScoreOfSection: number): {
  totalScore: number;
  languageNameScore: number;
  proficiencyScore: number;
  descriptionScore: number;
} => {
  const numberOfLanguages = languages.individualLanguagesAnalysis.length;
  const scorePerLanguage = maxScoreOfSection / numberOfLanguages;

  let languageNameScore = 0;
  let proficiencyScore = 0;
  let descriptionScore = 0;

  languages.individualLanguagesAnalysis.forEach((language) => {
    if (language.language) {
      languageNameScore += scorePerLanguage * NON_CORE_SECTION_SCORES_MAP.languages.languageName;
    }
    if (language.level) {
      proficiencyScore += scorePerLanguage * NON_CORE_SECTION_SCORES_MAP.languages.proficiencyLevel;
    }
    if (language.descriptionAnalysis.length > 0) {
      const numberOfDescriptions = language.descriptionAnalysis.length;
      const scorePerDescription = scorePerLanguage * NON_CORE_SECTION_SCORES_MAP.languages.statementWeight / numberOfDescriptions;
      language.descriptionAnalysis.forEach((description) => {
        const descriptionScoreResult = getStatementScore(description.analysis, scorePerDescription);
        descriptionScore += descriptionScoreResult.totalScore;
      });
      descriptionScore = Math.min(descriptionScore, scorePerLanguage * NON_CORE_SECTION_SCORES_MAP.languages.statementWeight);
    }
  })
  return {
    totalScore: languageNameScore + proficiencyScore + descriptionScore,
    languageNameScore,
    proficiencyScore,
    descriptionScore
  }
}
